import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import { registerSystemAdminPage } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-page"

/**
 * Registers a System Admin extension as a left-hand nav page within the System Admin
 * application. Kept as `registerSystemAdminTab` for backwards compatibility with the
 * existing call sites; internally it now creates a nav page (route + sidebar item)
 * rather than a horizontal tab.
 *
 * @param {string} name - Display name (sidebar label and page title).
 * @param {React.ReactNode} content - The page content.
 * @param {() => boolean} [predicate] - Controls nav-item visibility.
 * @param {number} [priority] - Sidebar ordering (lower first).
 * @param {string|React.ReactNode} [icon] - Iconify key (or element) for the nav item.
 * @param {string} [group] - Section heading to sit under; see system-admin-sections.js.
 */
export function registerSystemAdminTab(name, content, predicate = () => true, priority = 100, icon, group) {
    registerSystemAdminPage({
        name,
        path: slugify(name),
        // A System Admin page is reached from the sidebar and has no parent, so the crumb trail
        // would be a single crumb repeating the heading beneath it, and Back would be
        // window.history.back() — leaving the application the user just picked. Title only.
        content: (
            <PageBreadcrumbContainer title={name} hideCrumbs backButton={null}>
                {content}
            </PageBreadcrumbContainer>
        ),
        icon,
        predicate,
        priority,
        group,
    })
}

function slugify(name) {
    return name
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
}
